import React from 'react';
import { NavLink } from 'react-router-dom';
import { NavItem } from 'reactstrap';

import { accounts, merchants, quotesOrOpportunities } from '../utils';

function AccountingNavigation() {
  return (
    <>
      <NavItem>
        <NavLink className="nav-link" to="/dashboard/accounting">
          Overview
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          className="nav-link"
          to="/opportunities"
          isActive={quotesOrOpportunities}
        >
          Opportunities
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink className="nav-link" to="/campaigns">
          Campaigns
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink className="nav-link" to="/invoices">
          Invoices
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink className="nav-link" to="/accounts" isActive={accounts}>
          Accounts
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink className="nav-link" to="/merchants" isActive={merchants}>
          Merchants
        </NavLink>
      </NavItem>
    </>
  );
}

export default AccountingNavigation;
